import { config } from '@static/js/env.config';
import queryString from 'query-string';

export interface QueryRedirectURL {
  url: string;
  provider?: string;
  guests?: string;
  patform?: string;
  eventId?: string;
  userId?: string;
}

/**
 * Format a URL to be passed through the backend redirect
 * @param query
 * @returns
 */
export const formatRedirectURL = (query: Partial<QueryRedirectURL>) => {
  if (!shouldWrapWithRedirectService(query.url)) {
    return query.url;
  }
  return queryString.stringifyUrl({
    url: `${config.redirectServiceUri}/redirect`,
    query: query,
  });
};

/**
 * Checks whether the given URL is external and should be wrapped with the redirect service.
 * URLs pointing to `withjoy.com` or its subdomains are considered internal.
 *
 * @param {string} url - The URL to evaluate.
 * @returns {boolean} - `true` if the URL is external; `false` otherwise.
 */
const shouldWrapWithRedirectService = (url?: string): boolean => {
  if (!url) return true;
  try {
    const { hostname } = new URL(url);
    const isInternal = hostname === 'withjoy.com' || hostname.endsWith('.withjoy.com');
    return !isInternal;
  } catch {
    return true;
  }
};
